/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum PaginationMode {
    Compact,
    CompactWithCurrentPage,
    Full,
}
